import { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import BaseAppBar from "./AppBar";
import SideBar from "./SideBar";
import RouteService from "../service/routeService";
import { useLocation } from "react-router-dom";

const LayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 10,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 280,
  },
}));

export default function AppLayout(props) {
  const { children } = props;
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const location = useLocation();
  // Access URL components
  const pathname = location.pathname; // Get the pathname (path after the domain)
  const isHome = pathname.split("/")[1] == "home" ? true : false; // Remove "/"

  return (
    <Box
      sx={{
        backgroundColor: isHome ? "#1D589D" : "#FFFF",
        height: "100vh",
      }}
    >
      <LayoutRoot>
        <Box
          sx={{
            display: "flex",
            mt: 2,
            flex: "1 1 auto",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {children}
        </Box>
      </LayoutRoot>
      <BaseAppBar onSidebarOpen={() => setSidebarOpen(true)} />
      <SideBar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Box
        sx={{
          marginLeft: { lg: isHome ? 0 : 8 },
        }}
      >
        <Box sx={{ marginY: 2, marginX: 4 }}>
          <RouteService />
        </Box>
      </Box>
    </Box>
  );
}
